if (!customElements.get("search-pagination")) {
  class SearchPagination extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      const href = event.target.getAttribute("href");
      if (!href) return;

      const url = new URL(window.location.href);
      url.searchParams.set("page", href.split("?page=")[1]);

      window.location.assign(url);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClickRef);
    }
  }

  customElements.define("search-pagination", SearchPagination);
}
